<template>
  <div>
    <svg
      v-if="name === KCELL"
      xmlns="http://www.w3.org/2000/svg"
      width="83"
      height="24"
      viewBox="0 0 83 24"
      fill="none"
    >
      <g clip-path="url(#clip0_2384_14902)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0.467532V23.5325H5.2987V16.2078C5.2987 15.8961 7.79221 13.2468 8.41558 13.0909L14.026 21.5065C15.8961 24 18.3896 23.5325 21.8182 23.5325C21.3506 22.5974 20.1039 21.039 19.3247 19.9481L11.6883 9.50649C12.1558 8.88312 16.3636 4.98701 17.7662 3.11688C18.3896 2.49351 20.4156 0.779221 20.5714 0C15.1169 0 14.3377 0 10.5974 4.05195L5.2987 9.66234C5.2987 5.14286 6.23377 1.24675 3.11688 0.311688C2.33766 0.155844 2.18182 0.311688 1.4026 0.155844C1.09091 0.155844 0 -0.311688 0 0.467532Z"
          fill="#B0B7C3"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M39.2715 14.4931C39.2715 16.9866 39.739 19.1684 41.2975 20.8827L42.3884 21.9736C42.7001 22.2853 42.7001 22.2853 43.0117 22.4411C46.2845 24.623 52.0507 24.4671 54.7 21.0385C55.791 19.636 55.6351 19.1684 56.2585 18.0775C55.6351 18.0775 53.1416 18.0775 52.6741 18.0775C52.3624 18.0775 52.0507 18.3892 51.8949 18.545C51.4273 19.0126 52.0507 18.7009 50.6481 19.636C49.4014 20.4152 45.8169 20.571 44.8819 18.0775C44.5702 17.2983 44.5702 16.8308 44.5702 16.0515H56.726C56.726 13.7139 56.726 13.4022 55.9468 11.0645C54.0767 5.29829 45.8169 3.42816 41.1416 9.35023C39.8949 10.7528 39.2715 12.9347 39.2715 14.4931ZM51.4273 13.0905H44.1026C44.1026 9.03855 49.0897 9.03855 50.3364 10.4411C50.8039 10.9087 51.4273 12.3113 51.4273 13.0905Z"
          fill="#B0B7C3"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.7285 14.9612C20.7285 25.5586 33.5077 26.182 36.7805 19.9482C37.248 19.0132 37.4038 17.9223 37.7155 16.9872C36.7805 16.9872 35.8454 16.9872 34.7545 16.9872C34.287 16.9872 33.9753 16.9872 33.5077 17.1431C32.4168 17.7664 32.8844 18.5457 31.6376 19.6366C30.7025 20.4158 28.8324 20.5716 27.5857 19.9482C25.0922 18.3898 25.0922 13.8703 26.0272 11.8444C26.6506 10.5976 27.5857 9.81838 29.1441 9.66253C30.235 9.50669 31.4818 10.1301 32.1051 11.0651C32.261 11.3768 32.5727 12.156 32.8844 12.3119C33.5077 12.7794 36.0012 12.6236 36.9363 12.6236C38.0272 12.6236 36.6246 9.03916 35.0662 7.7924C29.1441 3.42877 20.7285 6.85734 20.7285 14.9612Z"
          fill="#B0B7C3"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M59.0653 0.467635C59.0653 3.58452 58.9095 19.6365 59.2212 21.3507C59.6887 23.5326 61.8705 23.5326 63.7407 23.5326V3.11698C63.7407 0.31179 62.0264 0.31179 60.6238 0.155946C60.1562 0.155946 59.0653 -0.311586 59.0653 0.467635Z"
          fill="#B0B7C3"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M67.9492 0.467635V19.9482C67.9492 20.8832 68.2609 22.13 68.7284 22.5975C69.6635 23.5326 71.3778 23.5326 72.6246 23.5326V3.11698C72.6246 0.31179 70.9103 0.31179 69.5077 0.155946C69.0401 0.155946 67.9492 -0.311586 67.9492 0.467635Z"
          fill="#B0B7C3"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M79.1689 0.467359V3.58424H79.7923L79.9482 1.55827C79.9482 2.18164 80.104 2.33749 80.104 2.80502C80.2599 3.58424 80.104 3.58424 81.0391 3.58424C81.1949 3.11671 81.3508 2.49333 81.3508 2.0258H81.5066C81.5066 3.4284 81.1949 3.58424 82.2858 3.58424C82.2858 -0.311862 82.5975 -0.000173651 81.3508 -0.000173651C81.1949 0.467359 80.7274 1.71411 80.7274 2.33749H80.5715C80.5715 1.86996 80.2599 0.311515 79.9482 -0.000173651C79.4806 -0.000173651 79.1689 -0.000173674 79.1689 0.467359Z"
          fill="#B0B7C3"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M76.208 0.46727C76.208 0.934803 76.5197 0.934803 77.1431 0.934803V3.58415H77.9223V0.934803C78.5457 0.934803 78.8573 1.09065 78.8573 0.46727C78.8573 -0.156106 78.0781 -0.000262111 76.6755 -0.000262111C76.3639 -0.000262111 76.208 0.155582 76.208 0.46727Z"
          fill="#B0B7C3"
        />
      </g>
      <defs>
        <clipPath id="clip0_2384_14902">
          <rect
            width="82.4416"
            height="24"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-if="name === TELE2"
      xmlns="http://www.w3.org/2000/svg"
      width="63"
      height="24"
      viewBox="0 0 63 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M54.0603 0.0686399V5.17081C57.3403 5.17081 56.4899 8.57225 54.9107 10.5159C54.6677 10.7589 54.4248 11.0019 54.1818 11.3663C53.9389 11.6093 53.6959 11.8522 53.4529 12.0952C52.6026 13.067 51.3878 14.1603 50.4159 15.1322C49.93 15.6181 49.3227 16.104 48.9582 16.59L47.3789 18.0477L55.0322 17.8048C55.2752 17.5618 55.3966 17.4403 55.5181 17.3188L56.4899 16.2255C56.9759 15.6181 57.9477 14.6463 58.4337 14.0389C58.5551 13.7959 58.6766 13.6744 58.9195 13.4315C61.4706 10.1515 63.2929 5.29229 60.2559 1.76936C58.6766 0.190113 56.247 -0.174321 54.0603 0.0686399Z"
        fill="#B0B7C3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M32.6797 3.71336V23.8791H37.2959V3.10596L32.6797 3.71336Z"
        fill="#B0B7C3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M46.4062 19.0194V23.8786H62.0772V18.5334L46.4062 19.0194Z"
        fill="#B0B7C3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.017 5.41355L20.8955 23.8786H24.9043V4.80615L21.017 5.41355Z"
        fill="#B0B7C3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.3271 6.87141V23.8787H13.8501V6.3855L10.3271 6.87141Z"
        fill="#B0B7C3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M46.6473 10.1518L51.5065 9.6659C51.5065 8.32961 51.2636 6.02149 53.2073 5.41409V0.19043C48.3481 0.919312 46.1614 5.65706 46.6473 10.1518Z"
        fill="#B0B7C3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.91532 12.095C2.79384 12.8239 2.91532 16.9542 2.91532 18.0476C2.91532 19.9912 2.79384 22.0564 2.91532 24.0001H6.1953V11.8521L2.91532 12.095Z"
        fill="#B0B7C3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 8.45126V11.8527L9.11102 10.8809V7.11499L0 8.45126Z"
        fill="#B0B7C3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.2649 19.2623C38.1435 19.6267 38.1435 23.2711 38.2649 23.8785H44.9464V19.0193L38.2649 19.2623Z"
        fill="#B0B7C3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.1465 2.86258V7.60031L44.9494 6.87142V2.01221L38.1465 2.86258Z"
        fill="#B0B7C3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.6318 19.6273V23.8791H31.4629V19.5059L25.6318 19.6273Z"
        fill="#B0B7C3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.2646 11.0021V15.7399L42.638 15.4969C42.7595 15.1325 42.7595 11.2451 42.638 10.6377L38.2646 11.0021Z"
        fill="#B0B7C3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.5795 19.9916L14.458 23.879H19.5602V19.8701L14.5795 19.9916Z"
        fill="#B0B7C3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.5795 6.38563L14.458 10.273L19.5602 9.66559V5.65674L14.5795 6.38563Z"
        fill="#B0B7C3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.5795 13.1887L14.458 17.076L17.8594 16.9545V12.8242L14.5795 13.1887Z"
        fill="#B0B7C3"
      />
    </svg>
    <svg
      v-if="name === ALTEL"
      xmlns="http://www.w3.org/2000/svg"
      width="114"
      height="20"
      viewBox="0 0 114 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M55.3726 11.1373C55.3726 9.46925 55.3726 7.80118 55.3726 6.13311C53.2496 6.13311 50.5201 6.58804 50.3684 4.01011H62.9548C62.8031 6.73968 59.467 5.82982 57.799 6.13311C57.344 9.77254 58.7088 14.9284 56.4341 14.7767C54.9177 14.9284 55.3726 12.5021 55.3726 11.1373ZM19.13 14.9284C19.13 14.4735 23.0727 7.64954 23.8309 6.28475C24.4375 5.22325 24.7409 4.16175 26.2573 4.16175C27.7737 4.16175 28.077 5.22325 28.6835 6.28475C29.4417 7.64954 33.2328 14.4735 33.3844 14.9284C30.6548 15.08 30.1999 13.412 29.1384 11.4406C28.6835 10.5308 26.7122 6.73968 26.2573 6.4364C25.954 6.73968 23.9826 10.2275 23.9826 10.834C24.8925 10.834 26.2572 10.6824 27.1671 10.9857C27.7737 11.289 28.5319 12.0472 28.5319 12.8054H22.9211C21.8596 13.7152 21.8596 15.08 19.13 14.9284ZM49.3069 14.9284C47.6388 15.08 45.5159 14.9284 43.8478 14.9284C37.6305 14.9284 38.5403 15.6866 38.5403 9.46925C38.5403 7.80118 38.3887 5.67818 38.5403 4.16175C42.0281 4.01011 40.6633 8.55939 40.9666 12.957C42.1797 13.1087 44.7577 12.957 46.1224 12.957C47.7905 12.957 49.3069 13.2603 49.3069 14.9284ZM0.0229994 19.781C0.174642 19.9326 -0.280268 19.9326 0.326303 19.9326C19.13 19.9326 37.9337 19.9326 56.7374 19.9326H106.021C107.689 19.9326 111.784 20.0842 113.149 19.9326C113.452 19.326 113.452 0.673968 113.149 0.0673968C112.087 -0.084246 103.747 0.0673968 101.927 0.0673968H23.0727C22.6178 0.0673968 22.6179 0.0673968 22.4662 0.21904C20.0399 -0.084246 15.6422 0.977254 13.6709 1.73547C8.81828 3.40354 4.87559 7.04297 2.60095 11.5922C1.23616 13.7152 0.174642 16.8997 0.0229994 19.781ZM76.6026 6.13311C75.6928 6.13311 70.6886 5.98147 70.082 6.28475C69.9304 6.89132 69.9304 7.95282 70.082 8.55939L73.7215 8.71104C74.4797 9.01432 75.0862 9.46925 75.0862 10.5308H70.082V12.8054C71.9017 13.2603 76.1477 12.3505 77.5125 13.2603C77.9675 13.5636 78.4223 14.1702 78.4223 14.9284C75.6928 14.9284 72.9632 14.9284 70.3853 14.9284C67.0492 14.9284 67.6557 14.9284 67.6557 9.62089C67.6557 4.16175 67.2008 4.16175 70.3853 4.16175C73.1149 4.16175 75.8444 4.16175 78.4223 4.16175C78.4223 5.37489 77.6641 6.13311 76.6026 6.13311ZM92.6768 13.1087C93.5867 13.1087 94.3448 14.0185 94.3448 14.9284C92.6768 15.08 90.5538 14.9284 88.8857 14.9284C82.82 14.9284 83.5782 15.8382 83.5782 9.46925C83.5782 7.80118 83.4266 5.67818 83.5782 4.16175C84.7914 4.01011 86.1562 4.91997 85.8529 6.13311C85.8529 7.19461 85.7012 12.3505 86.0045 13.1087C87.5209 13.2603 90.8571 12.957 92.6768 13.1087Z"
        fill="#B0B7C3"
      />
    </svg>
    <svg
      v-if="name === 'activ'"
      xmlns="http://www.w3.org/2000/svg"
      width="83"
      height="24"
      viewBox="0 0 83 24"
      fill="none"
    >
      <g clip-path="url(#clip0_2384_14931)">
        <path
          d="M40.7148 7.1353V8.03343C39.8666 7.33489 38.7689 6.93572 37.5215 6.93572C34.5776 6.93572 32.1826 9.43052 32.1826 12.7237C32.1826 14.2205 32.7315 15.6176 33.5797 16.6156C34.5277 17.7632 36.0745 18.5116 37.6712 18.5116C38.7689 18.5116 39.8167 18.1623 40.7148 17.4139V18.312H43.509V7.1353H40.7148ZM40.6151 14.3203C40.0662 15.1187 39.0683 15.6675 37.9706 15.6675C36.324 15.6675 35.0766 14.3702 35.0766 12.6239C35.0766 11.0272 36.1743 9.58021 37.8708 9.58021C39.0184 9.58021 39.9664 10.1291 40.5652 10.9773V14.3203H40.6151ZM55.7336 15.9669C54.4363 17.7133 52.8396 18.4617 50.7938 18.4617C47.4009 18.4617 44.9061 15.917 44.9061 12.6738C44.9061 9.43052 47.4508 6.88582 50.7938 6.88582C52.6899 6.88582 54.3864 7.78395 55.3843 9.08125L53.3385 10.9274C52.7398 10.1291 51.8916 9.58021 50.8437 9.58021C49.1473 9.58021 47.8999 10.9274 47.8999 12.6239C47.8999 14.3702 49.1473 15.6675 50.8936 15.6675C52.0911 15.6675 53.0392 14.9191 53.4882 14.2205L55.7336 15.9669ZM64.4155 18.2122C64.0163 18.3619 63.1681 18.4617 62.6192 18.4617C60.8728 18.4617 59.5756 17.863 58.8271 16.865C58.2783 16.1166 58.0288 15.1187 58.0288 13.5719V9.68H56.1826V7.1852H58.0288V4.04175H60.9726V7.1353H64.4654V9.63011H60.9726V13.8713C60.9726 14.5698 61.0724 14.969 61.3219 15.2684C61.6213 15.6176 62.0704 15.8172 62.8188 15.8172C63.2679 15.8172 63.8167 15.7673 64.0163 15.7174L64.4155 18.2122ZM66.4113 7.1353H69.3552V18.2122H66.4113V7.1353ZM82.6774 7.1353L77.6878 18.2122H75.6421L70.6026 7.1353H73.6462L76.64 13.9212L79.6338 7.1353H82.6774Z"
          fill="#B0B7C3"
        />
        <path
          d="M25.5964 9.87952C25.5964 9.97931 25.4966 10.0791 25.3969 10.0791C25.2971 10.0791 25.1973 9.97931 25.1973 9.87952C25.1973 9.77972 25.2971 9.67993 25.3969 9.67993C25.4966 9.67993 25.5964 9.77972 25.5964 9.87952Z"
          fill="#B0B7C3"
        />
        <path
          d="M24.9974 5.58838C24.8976 5.58838 24.7979 5.68817 24.7979 5.78796C24.7979 5.88776 24.8976 5.98755 24.9974 5.98755C25.0972 5.98755 25.197 5.88776 25.197 5.78796C25.1471 5.68817 25.0972 5.58838 24.9974 5.58838Z"
          fill="#B0B7C3"
        />
        <path
          d="M9.18042 2.94397C9.18042 2.84418 9.08063 2.74438 8.98083 2.74438C8.88104 2.74438 8.78125 2.84418 8.78125 2.94397C8.78125 3.04376 8.88104 3.14355 8.98083 3.14355C9.08063 3.14355 9.18042 3.04376 9.18042 2.94397Z"
          fill="#B0B7C3"
        />
        <path
          d="M18.2621 4.24121C18.3619 4.24121 18.4617 4.14142 18.4617 4.04163C18.4617 3.94183 18.3619 3.84204 18.2621 3.84204C18.1623 3.84204 18.0625 3.94183 18.0625 4.04163C18.0625 4.14142 18.1623 4.24121 18.2621 4.24121Z"
          fill="#B0B7C3"
        />
        <path
          d="M11.0769 4.19128C11.0769 4.09149 10.9771 3.9917 10.8773 3.9917C10.7775 3.9917 10.6777 4.09149 10.6777 4.19128C10.6777 4.29108 10.7775 4.39087 10.8773 4.39087C10.9771 4.34097 11.0769 4.29108 11.0769 4.19128Z"
          fill="#B0B7C3"
        />
        <path
          d="M24.7484 7.18506C24.8482 7.18506 24.948 7.08526 24.948 6.98547C24.948 6.88568 24.8482 6.78589 24.7484 6.78589C24.6486 6.78589 24.5488 6.88568 24.5488 6.98547C24.5488 7.08526 24.6486 7.18506 24.7484 7.18506Z"
          fill="#B0B7C3"
        />
        <path
          d="M21.2559 8.53225C21.2559 9.48028 22.0542 10.2786 23.0022 10.2786C23.9502 10.2786 24.7486 9.48028 24.7486 8.53225C24.7486 7.58423 23.9502 6.78589 23.0022 6.78589C22.0542 6.78589 21.2559 7.58423 21.2559 8.53225Z"
          fill="#B0B7C3"
        />
        <path
          d="M22.1543 5.93769C22.1543 6.33685 22.4537 6.63623 22.8528 6.63623C23.252 6.63623 23.5514 6.33685 23.5514 5.93769C23.5514 5.53852 23.252 5.23914 22.8528 5.23914C22.5036 5.18925 22.1543 5.53852 22.1543 5.93769Z"
          fill="#B0B7C3"
        />
        <path
          d="M22.0046 6.68616C22.0046 6.58636 21.9048 6.48657 21.8051 6.48657C21.7053 6.48657 21.6055 6.58636 21.6055 6.68616C21.6055 6.78595 21.7053 6.88574 21.8051 6.88574C21.9048 6.88574 22.0046 6.78595 22.0046 6.68616Z"
          fill="#B0B7C3"
        />
        <path
          d="M21.8545 4.54068C21.8545 4.74026 22.0541 4.88995 22.2038 4.88995C22.4033 4.88995 22.553 4.74026 22.553 4.54068C22.553 4.34109 22.4033 4.19141 22.2038 4.19141C22.0042 4.19141 21.8545 4.34109 21.8545 4.54068Z"
          fill="#B0B7C3"
        />
        <path
          d="M21.8549 3.54272C21.9546 3.54272 22.0544 3.44293 22.0544 3.34314C22.0544 3.24335 21.9546 3.14355 21.8549 3.14355C21.7551 3.14355 21.6553 3.24335 21.6553 3.34314C21.6553 3.49283 21.7551 3.54272 21.8549 3.54272Z"
          fill="#B0B7C3"
        />
        <path
          d="M21.2559 5.88779C21.2559 6.08737 21.4055 6.23706 21.6051 6.23706C21.8047 6.23706 21.9544 6.08737 21.9544 5.88779C21.9544 5.6882 21.8047 5.53852 21.6051 5.53852C21.4055 5.48862 21.2559 5.6882 21.2559 5.88779Z"
          fill="#B0B7C3"
        />
        <path
          d="M18.4619 4.84005C18.4619 5.63839 19.1106 6.28704 19.9089 6.28704C20.7072 6.28704 21.3559 5.63839 21.3559 4.84005C21.3559 4.04171 20.7072 3.39307 19.9089 3.39307C19.1106 3.39307 18.4619 4.04171 18.4619 4.84005Z"
          fill="#B0B7C3"
        />
        <path
          d="M19.5092 2.74438C19.6089 2.74438 19.7087 2.64459 19.7087 2.5448C19.7087 2.44501 19.6089 2.34521 19.5092 2.34521C19.4094 2.34521 19.3096 2.44501 19.3096 2.5448C19.3595 2.69449 19.4094 2.74438 19.5092 2.74438Z"
          fill="#B0B7C3"
        />
        <path
          d="M18.7105 3.59259C18.9101 3.59259 19.0598 3.4429 19.0598 3.24332C19.0598 3.04373 18.9101 2.89404 18.7105 2.89404C18.511 2.89404 18.3613 3.04373 18.3613 3.24332C18.3114 3.4429 18.511 3.59259 18.7105 3.59259Z"
          fill="#B0B7C3"
        />
        <path
          d="M16.5654 2.69452C16.5654 3.09369 16.8648 3.39307 17.264 3.39307C17.6631 3.39307 17.9625 3.09369 17.9625 2.69452C17.9625 2.29535 17.6631 1.99598 17.264 1.99598C16.8648 1.94608 16.5654 2.29535 16.5654 2.69452Z"
          fill="#B0B7C3"
        />
        <path
          d="M16.6654 0.898192C16.7652 0.898192 16.865 0.7984 16.865 0.698608C16.865 0.598816 16.7652 0.499023 16.6654 0.499023C16.5656 0.499023 16.4658 0.598816 16.4658 0.698608C16.4658 0.7984 16.5656 0.898192 16.6654 0.898192Z"
          fill="#B0B7C3"
        />
        <path
          d="M16.6156 3.9917C16.7154 3.9917 16.8152 3.89191 16.8152 3.79211C16.8152 3.69232 16.7154 3.59253 16.6156 3.59253C16.5158 3.59253 16.416 3.69232 16.416 3.79211C16.416 3.89191 16.5158 3.9917 16.6156 3.9917Z"
          fill="#B0B7C3"
        />
        <path
          d="M22.3539 14.1707C22.2541 14.1707 22.1543 14.2704 22.1543 14.3702C22.1543 14.47 22.2541 14.5698 22.3539 14.5698C22.4537 14.5698 22.5535 14.47 22.5535 14.3702C22.5535 14.2704 22.4537 14.1707 22.3539 14.1707Z"
          fill="#B0B7C3"
        />
        <path
          d="M12.624 3.89196C12.624 4.88988 13.4224 5.68822 14.4203 5.68822C15.4182 5.68822 16.2165 4.88988 16.2165 3.89196C16.2165 2.89404 15.4182 2.0957 14.4203 2.0957C13.4224 2.0957 12.624 2.89404 12.624 3.89196Z"
          fill="#B0B7C3"
        />
        <path
          d="M15.5172 2.04571C15.7168 2.04571 15.8665 1.89602 15.8665 1.69644C15.8665 1.49686 15.7168 1.34717 15.5172 1.34717C15.3177 1.34717 15.168 1.49686 15.168 1.69644C15.168 1.89602 15.3177 2.04571 15.5172 2.04571Z"
          fill="#B0B7C3"
        />
        <path
          d="M14.7689 0.898192C14.8687 0.898192 14.9685 0.7984 14.9685 0.698608C14.9685 0.598816 14.8687 0.499023 14.7689 0.499023C14.6691 0.499023 14.5693 0.598816 14.5693 0.698608C14.6192 0.7984 14.6691 0.898192 14.7689 0.898192Z"
          fill="#B0B7C3"
        />
        <path
          d="M13.0228 2.49487C13.1226 2.49487 13.2224 2.39508 13.2224 2.29529C13.2224 2.1955 13.1226 2.0957 13.0228 2.0957C12.923 2.0957 12.8232 2.1955 12.8232 2.29529C12.8232 2.44498 12.923 2.49487 13.0228 2.49487Z"
          fill="#B0B7C3"
        />
        <path
          d="M12.5736 5.1394C12.6734 5.1394 12.7732 5.03961 12.7732 4.93982C12.7732 4.84003 12.6734 4.74023 12.5736 4.74023C12.4738 4.74023 12.374 4.84003 12.374 4.93982C12.374 5.08951 12.4738 5.1394 12.5736 5.1394Z"
          fill="#B0B7C3"
        />
        <path
          d="M11.9749 3.39294C12.3741 3.39294 12.6735 3.09356 12.6735 2.69439C12.6735 2.29523 12.3741 1.99585 11.9749 1.99585C11.5757 1.99585 11.2764 2.29523 11.2764 2.69439C11.2764 3.04367 11.5757 3.39294 11.9749 3.39294Z"
          fill="#B0B7C3"
        />
        <path
          d="M10.9271 2.74438C11.0269 2.74438 11.1267 2.64459 11.1267 2.5448C11.1267 2.44501 11.0269 2.34521 10.9271 2.34521C10.8273 2.34521 10.7275 2.44501 10.7275 2.5448C10.7275 2.64459 10.8273 2.74438 10.9271 2.74438Z"
          fill="#B0B7C3"
        />
        <path
          d="M10.8278 3.59259C11.0274 3.59259 11.1771 3.4429 11.1771 3.24332C11.1771 3.04373 11.0274 2.89404 10.8278 2.89404C10.6282 2.89404 10.4785 3.04373 10.4785 3.24332C10.4785 3.4429 10.6282 3.59259 10.8278 3.59259Z"
          fill="#B0B7C3"
        />
        <path
          d="M12.823 6.0874C13.0226 6.0874 13.2222 5.93771 13.2222 5.68823C13.2222 5.48865 13.0725 5.28906 12.823 5.28906C12.6234 5.28906 12.4238 5.43875 12.4238 5.68823C12.4737 5.88781 12.6234 6.0874 12.823 6.0874Z"
          fill="#B0B7C3"
        />
        <path
          d="M12.4243 3.94189C12.4243 3.74231 12.2746 3.54272 12.0251 3.54272C11.8256 3.54272 11.626 3.69241 11.626 3.94189C11.626 4.14148 11.7757 4.34106 12.0251 4.34106C12.2247 4.34106 12.4243 4.14148 12.4243 3.94189Z"
          fill="#B0B7C3"
        />
        <path
          d="M13.2725 6.13727C13.2725 6.28696 13.4221 6.43664 13.5718 6.43664C13.7215 6.43664 13.8712 6.28696 13.8712 6.13727C13.8712 5.98758 13.7215 5.83789 13.5718 5.83789C13.3723 5.83789 13.2725 5.98758 13.2725 6.13727Z"
          fill="#B0B7C3"
        />
        <path
          d="M9.72968 2.54479C10.1288 2.54479 10.4282 2.24542 10.4282 1.84625C10.4282 1.44708 10.1288 1.14771 9.72968 1.14771C9.33051 1.14771 9.03113 1.44708 9.03113 1.84625C8.98124 2.24542 9.33051 2.54479 9.72968 2.54479Z"
          fill="#B0B7C3"
        />
        <path
          d="M8.73203 1.14761C8.93161 1.14761 9.0813 0.997923 9.0813 0.748442C9.0813 0.548858 8.93161 0.39917 8.73203 0.39917C8.53244 0.39917 8.38275 0.548858 8.38275 0.748442C8.33286 0.997923 8.53244 1.14761 8.73203 1.14761Z"
          fill="#B0B7C3"
        />
        <path
          d="M8.13318 0.349364C8.23297 0.349364 8.33276 0.249572 8.33276 0.14978C8.33276 0.0499874 8.23297 -0.0498047 8.13318 -0.0498047C8.03339 -0.0498047 7.93359 0.0499874 7.93359 0.14978C7.93359 0.299468 8.03339 0.349364 8.13318 0.349364Z"
          fill="#B0B7C3"
        />
        <path
          d="M7.58404 3.89196C8.18279 3.89196 8.68175 3.393 8.68175 2.79425C8.68175 2.19549 8.18279 1.69653 7.58404 1.69653C6.98529 1.69653 6.48633 2.19549 6.48633 2.79425C6.53622 3.393 6.98529 3.89196 7.58404 3.89196Z"
          fill="#B0B7C3"
        />
        <path
          d="M6.83542 1.49707C6.93521 1.49707 6.98511 1.39728 6.98511 1.29748C6.98511 1.19769 6.88531 1.0979 6.78552 1.0979C6.68573 1.0979 6.58594 1.19769 6.58594 1.29748C6.63583 1.39728 6.73563 1.49707 6.83542 1.49707Z"
          fill="#B0B7C3"
        />
        <path
          d="M6.18689 2.94385C6.28668 2.94385 6.38647 2.84405 6.38647 2.74426C6.38647 2.64447 6.28668 2.54468 6.18689 2.54468C6.0871 2.54468 5.9873 2.64447 5.9873 2.74426C5.9873 2.84405 6.0871 2.94385 6.18689 2.94385Z"
          fill="#B0B7C3"
        />
        <path
          d="M3.39258 4.59062C3.39258 5.58854 4.19091 6.33698 5.13894 6.33698C6.13686 6.33698 6.8853 5.53865 6.8853 4.59062C6.8853 3.5927 6.08696 2.84426 5.13894 2.84426C4.19091 2.79436 3.39258 3.5927 3.39258 4.59062Z"
          fill="#B0B7C3"
        />
        <path
          d="M3.64224 2.99395C3.84183 2.99395 3.99151 2.84427 3.99151 2.64468C3.99151 2.4451 3.84183 2.29541 3.64224 2.29541C3.44266 2.29541 3.29297 2.4451 3.29297 2.64468C3.29297 2.84427 3.44266 2.99395 3.64224 2.99395Z"
          fill="#B0B7C3"
        />
        <path
          d="M3.09341 5.9378C3.293 5.9378 3.44269 5.78811 3.44269 5.58853C3.44269 5.38895 3.293 5.23926 3.09341 5.23926C2.89383 5.23926 2.74414 5.38895 2.74414 5.58853C2.74414 5.78811 2.89383 5.9378 3.09341 5.9378Z"
          fill="#B0B7C3"
        />
        <path
          d="M1.19727 6.03741C1.19727 6.43658 1.49664 6.73596 1.89581 6.73596C2.29498 6.73596 2.59435 6.43658 2.59435 6.03741C2.59435 5.63824 2.29498 5.33887 1.89581 5.33887C1.54654 5.33887 1.19727 5.63824 1.19727 6.03741Z"
          fill="#B0B7C3"
        />
        <path
          d="M13.173 22.4534C12.8736 22.4534 12.5742 22.7028 12.5742 23.0521C12.5742 23.3515 12.8237 23.6509 13.173 23.6509C13.4723 23.6509 13.7717 23.4014 13.7717 23.0521C13.7717 22.7028 13.5222 22.4534 13.173 22.4534Z"
          fill="#B0B7C3"
        />
        <path
          d="M1.44687 4.8399C1.64646 4.8399 1.79614 4.69021 1.79614 4.49063C1.79614 4.29105 1.64646 4.14136 1.44687 4.14136C1.24729 4.14136 1.0976 4.29105 1.0976 4.49063C1.0477 4.64032 1.24729 4.8399 1.44687 4.8399Z"
          fill="#B0B7C3"
        />
        <path
          d="M1.54724 3.59253C1.64703 3.59253 1.74682 3.49274 1.74682 3.39294C1.74682 3.29315 1.64703 3.19336 1.54724 3.19336C1.44745 3.19336 1.34766 3.29315 1.34766 3.39294C1.34766 3.49274 1.44745 3.59253 1.54724 3.59253Z"
          fill="#B0B7C3"
        />
        <path
          d="M0.798217 7.43457C0.898009 7.43457 0.997801 7.33478 0.997801 7.23498C0.997801 7.13519 0.898009 7.0354 0.798217 7.0354C0.698425 7.0354 0.598633 7.13519 0.598633 7.23498C0.598633 7.33478 0.698425 7.43457 0.798217 7.43457Z"
          fill="#B0B7C3"
        />
        <path
          d="M0.698545 10.3285C0.698545 10.1289 0.548857 9.97925 0.349272 9.97925C0.149688 9.97925 0 10.1289 0 10.3285C0 10.5281 0.149688 10.6778 0.349272 10.6778C0.548857 10.6778 0.698545 10.5281 0.698545 10.3285Z"
          fill="#B0B7C3"
        />
        <path
          d="M0.548491 15.2183C0.348907 15.2183 0.199219 15.368 0.199219 15.5675C0.199219 15.7671 0.348907 15.9168 0.548491 15.9168C0.748075 15.9168 0.897763 15.7671 0.897763 15.5675C0.897763 15.4178 0.748075 15.2183 0.548491 15.2183Z"
          fill="#B0B7C3"
        />
        <path
          d="M2.09601 15.7173C1.69684 15.7173 1.39746 16.0167 1.39746 16.4158C1.39746 16.815 1.69684 17.1144 2.09601 17.1144C2.49517 17.1144 2.79455 16.815 2.79455 16.4158C2.79455 16.0167 2.49517 15.7173 2.09601 15.7173Z"
          fill="#B0B7C3"
        />
        <path
          d="M1.89587 18.262C1.79608 18.262 1.69629 18.3618 1.69629 18.4615C1.69629 18.5613 1.79608 18.6611 1.89587 18.6611C1.99567 18.6611 2.09546 18.5613 2.09546 18.4615C2.09546 18.3618 1.99567 18.262 1.89587 18.262Z"
          fill="#B0B7C3"
        />
        <path
          d="M3.64288 16.6155C3.24371 16.6155 2.94434 16.9149 2.94434 17.314C2.94434 17.7132 3.24371 18.0126 3.64288 18.0126C4.04205 18.0126 4.34143 17.6633 4.34143 17.314C4.34143 16.9149 4.04205 16.6155 3.64288 16.6155Z"
          fill="#B0B7C3"
        />
        <path
          d="M3.84244 18.3618C3.64285 18.3618 3.49316 18.5115 3.49316 18.7111C3.49316 18.9107 3.64285 19.0604 3.84244 19.0604C4.04202 19.0604 4.19171 18.9107 4.19171 18.7111C4.19171 18.5614 4.04202 18.3618 3.84244 18.3618Z"
          fill="#B0B7C3"
        />
        <path
          d="M3.8916 15.7672C3.8916 16.3161 4.34067 16.7651 4.88952 16.7651C5.43838 16.7651 5.88744 16.3161 5.88744 15.7672C5.88744 15.2184 5.43838 14.7693 4.88952 14.7693C4.34067 14.7693 3.8916 15.2184 3.8916 15.7672Z"
          fill="#B0B7C3"
        />
        <path
          d="M5.18921 6.73596C5.18921 6.63617 5.08942 6.53638 4.98962 6.53638C4.88983 6.53638 4.79004 6.63617 4.79004 6.73596C4.79004 6.83575 4.88983 6.93554 4.98962 6.93554C5.13931 6.88565 5.18921 6.83575 5.18921 6.73596Z"
          fill="#B0B7C3"
        />
        <path
          d="M10.0293 5.38879C10.0293 5.48859 10.1291 5.58838 10.2289 5.58838C10.3287 5.58838 10.4285 5.48859 10.4285 5.38879C10.4285 5.289 10.3287 5.18921 10.2289 5.18921C10.1291 5.23911 10.0293 5.289 10.0293 5.38879Z"
          fill="#B0B7C3"
        />
        <path
          d="M11.4265 3.79211C11.4265 3.69232 11.3267 3.59253 11.2269 3.59253C11.1271 3.59253 11.0273 3.69232 11.0273 3.79211C11.0273 3.89191 11.1271 3.9917 11.2269 3.9917C11.3766 3.9917 11.4265 3.89191 11.4265 3.79211Z"
          fill="#B0B7C3"
        />
        <path
          d="M11.626 6.38684C11.626 6.48663 11.7258 6.58642 11.8256 6.58642C11.9254 6.58642 12.0251 6.48663 12.0251 6.38684C12.0251 6.28705 11.9254 6.18726 11.8256 6.18726C11.7258 6.18726 11.626 6.28705 11.626 6.38684Z"
          fill="#B0B7C3"
        />
        <path
          d="M4.7905 14.5698C4.94018 14.5698 5.03998 14.47 5.03998 14.3203C5.03998 14.1706 4.94018 14.0708 4.7905 14.0708C4.64081 14.0708 4.54102 14.1706 4.54102 14.3203C4.54102 14.47 4.6907 14.5698 4.7905 14.5698Z"
          fill="#B0B7C3"
        />
        <path
          d="M4.69054 7.08526C4.69054 6.48651 4.19158 5.98755 3.59283 5.98755C2.99408 5.98755 2.49512 6.48651 2.49512 7.08526C2.49512 7.68401 2.99408 8.18297 3.59283 8.18297C4.19158 8.18297 4.69054 7.68401 4.69054 7.08526Z"
          fill="#B0B7C3"
        />
        <path
          d="M0.399414 11.5261C0.399414 11.9252 0.69879 12.2246 1.09796 12.2246C1.49713 12.2246 1.7965 11.9252 1.7965 11.5261C1.7965 11.1269 1.49713 10.8275 1.09796 10.8275C0.748686 10.7776 0.399414 11.1269 0.399414 11.5261Z"
          fill="#B0B7C3"
        />
        <path
          d="M2.19531 11.4262C2.19531 11.6258 2.345 11.7754 2.54458 11.7754C2.74417 11.7754 2.89386 11.6258 2.89386 11.4262C2.89386 11.2266 2.74417 11.0769 2.54458 11.0769C2.3949 11.0769 2.19531 11.2266 2.19531 11.4262Z"
          fill="#B0B7C3"
        />
        <path
          d="M4.04175 8.53235C4.04175 8.43256 3.94195 8.33276 3.84216 8.33276C3.74237 8.33276 3.64258 8.43256 3.64258 8.53235C3.64258 8.63214 3.74237 8.73193 3.84216 8.73193C3.99185 8.73193 4.04175 8.63214 4.04175 8.53235Z"
          fill="#B0B7C3"
        />
        <path
          d="M3.39322 11.576C3.5928 11.576 3.74249 11.4263 3.74249 11.2267C3.74249 11.0271 3.5928 10.8774 3.39322 10.8774C3.19363 10.8774 3.04395 11.0271 3.04395 11.2267C3.04395 11.4263 3.19363 11.576 3.39322 11.576Z"
          fill="#B0B7C3"
        />
        <path
          d="M3.74255 12.0251C3.84235 12.0251 3.94214 11.9254 3.94214 11.8256C3.94214 11.7258 3.84235 11.626 3.74255 11.626C3.64276 11.626 3.54297 11.7258 3.54297 11.8256C3.54297 11.9254 3.64276 12.0251 3.74255 12.0251Z"
          fill="#B0B7C3"
        />
        <path
          d="M2.94434 15.9669C2.94434 16.1665 3.09402 16.3162 3.29361 16.3162C3.49319 16.3162 3.64288 16.1665 3.64288 15.9669C3.64288 15.7673 3.49319 15.6176 3.29361 15.6176C3.14392 15.5677 2.94434 15.7673 2.94434 15.9669Z"
          fill="#B0B7C3"
        />
        <path
          d="M2.6947 15.4678C3.69262 15.4678 4.49095 14.6694 4.49095 13.6715C4.49095 12.6736 3.69262 11.8752 2.6947 11.8752C1.69677 11.8752 0.898438 12.6736 0.898438 13.6715C0.898437 14.6694 1.69677 15.4678 2.6947 15.4678Z"
          fill="#B0B7C3"
        />
        <path
          d="M2.39483 7.48453C2.39483 7.28494 2.24515 7.13525 2.04556 7.13525C1.84598 7.13525 1.69629 7.28494 1.69629 7.48453C1.69629 7.68411 1.84598 7.8338 2.04556 7.8338C2.19525 7.8338 2.39483 7.68411 2.39483 7.48453Z"
          fill="#B0B7C3"
        />
        <path
          d="M3.79241 9.53024C3.79241 8.7319 3.14376 8.08325 2.34542 8.08325C1.54709 8.08325 0.898438 8.7319 0.898438 9.53024C0.898438 10.3286 1.54709 10.9772 2.34542 10.9772C3.14376 10.9772 3.79241 10.3286 3.79241 9.53024Z"
          fill="#B0B7C3"
        />
        <path
          d="M7.93315 18.4617C7.93315 17.5137 7.13482 16.7153 6.18679 16.7153C5.18887 16.7153 4.44043 17.5137 4.44043 18.4617C4.44043 19.4097 5.23877 20.2081 6.18679 20.2081C7.13482 20.2081 7.93315 19.4097 7.93315 18.4617Z"
          fill="#B0B7C3"
        />
        <path
          d="M6.43683 20.9066C6.43683 20.7071 6.28714 20.5574 6.08755 20.5574C5.88797 20.5574 5.73828 20.7071 5.73828 20.9066C5.73828 21.1062 5.88797 21.2559 6.08755 21.2559C6.28714 21.2559 6.43683 21.1062 6.43683 20.9066Z"
          fill="#B0B7C3"
        />
        <path
          d="M6.63611 22.0042C6.53632 22.0042 6.43652 22.1039 6.43652 22.2037C6.43652 22.3035 6.53632 22.4033 6.63611 22.4033C6.7359 22.4033 6.83569 22.3035 6.83569 22.2037C6.83569 22.054 6.7359 22.0042 6.63611 22.0042Z"
          fill="#B0B7C3"
        />
        <path
          d="M7.28482 20.1582C7.08524 20.1582 6.93555 20.3079 6.93555 20.5075C6.93555 20.7071 7.08524 20.8567 7.28482 20.8567C7.4844 20.8567 7.63409 20.7071 7.63409 20.5075C7.63409 20.3079 7.4844 20.1582 7.28482 20.1582Z"
          fill="#B0B7C3"
        />
        <path
          d="M9.9298 19.9586C9.9298 19.3598 9.43084 18.8608 8.83209 18.8608C8.23334 18.8608 7.73438 19.3598 7.73438 19.9586C7.73438 20.5573 8.23334 21.0563 8.83209 21.0563C9.48074 21.0563 9.9298 20.5573 9.9298 19.9586Z"
          fill="#B0B7C3"
        />
        <path
          d="M8.93103 22.8025C8.83124 22.8025 8.73145 22.9023 8.73145 23.0021C8.73145 23.1019 8.83124 23.2017 8.93103 23.2017C9.03082 23.2017 9.13061 23.1019 9.13061 23.0021C9.13061 22.8524 9.03082 22.8025 8.93103 22.8025Z"
          fill="#B0B7C3"
        />
        <path
          d="M9.43033 21.0562C9.23074 21.0562 9.08105 21.2058 9.08105 21.4054C9.08105 21.605 9.23074 21.7547 9.43033 21.7547C9.62991 21.7547 9.7796 21.605 9.7796 21.4054C9.8295 21.2557 9.62991 21.0562 9.43033 21.0562Z"
          fill="#B0B7C3"
        />
        <path
          d="M10.279 22.3535C10.0794 22.3535 9.92969 22.5032 9.92969 22.7028C9.92969 22.9024 10.0794 23.0521 10.279 23.0521C10.4785 23.0521 10.6282 22.9024 10.6282 22.7028C10.6282 22.5032 10.4785 22.3535 10.279 22.3535Z"
          fill="#B0B7C3"
        />
        <path
          d="M9.48053 3.19336C8.88177 3.19336 8.38281 3.69232 8.38281 4.29107C8.38281 4.88983 8.88177 5.38879 9.48053 5.38879C10.0793 5.38879 10.5782 4.88983 10.5782 4.29107C10.5782 3.64242 10.0793 3.19336 9.48053 3.19336Z"
          fill="#B0B7C3"
        />
        <path
          d="M11.0772 20.208C10.4785 20.208 9.97949 20.707 9.97949 21.3057C9.97949 21.9045 10.4785 22.4034 11.0772 22.4034C11.676 22.4034 12.1749 21.9045 12.1749 21.3057C12.1749 20.707 11.676 20.208 11.0772 20.208Z"
          fill="#B0B7C3"
        />
        <path
          d="M11.9252 22.7029C11.8254 22.7029 11.7256 22.8027 11.7256 22.9025C11.7256 23.0023 11.8254 23.102 11.9252 23.102C12.025 23.102 12.1248 23.0023 12.1248 22.9025C12.0749 22.8027 12.025 22.7029 11.9252 22.7029Z"
          fill="#B0B7C3"
        />
        <path
          d="M12.4242 22.3535C12.3244 22.3535 12.2246 22.4533 12.2246 22.5531C12.2246 22.6529 12.3244 22.7527 12.4242 22.7527C12.524 22.7527 12.6238 22.6529 12.6238 22.5531C12.6238 22.4533 12.524 22.3535 12.4242 22.3535Z"
          fill="#B0B7C3"
        />
        <path
          d="M12.6237 21.5054C12.4241 21.5054 12.2744 21.6551 12.2744 21.8546C12.2744 22.0542 12.4241 22.2039 12.6237 22.2039C12.8233 22.2039 12.973 22.0542 12.973 21.8546C13.0229 21.6551 12.8233 21.5054 12.6237 21.5054Z"
          fill="#B0B7C3"
        />
        <path
          d="M12.7233 20.6072C12.5237 20.6072 12.374 20.7569 12.374 20.9565C12.374 21.156 12.5237 21.3057 12.7233 21.3057C12.9229 21.3057 13.0726 21.156 13.0726 20.9565C13.0726 20.7569 12.9229 20.6072 12.7233 20.6072Z"
          fill="#B0B7C3"
        />
        <path
          d="M13.2229 6.78601C13.2229 6.48663 12.9734 6.18726 12.6241 6.18726C12.3248 6.18726 12.0254 6.43674 12.0254 6.78601C12.0254 7.08539 12.2749 7.38476 12.6241 7.38476C12.9734 7.38476 13.2229 7.13528 13.2229 6.78601Z"
          fill="#B0B7C3"
        />
        <path
          d="M12.2746 5.2391C12.2746 4.79004 11.8754 4.39087 11.4264 4.39087C10.9773 4.39087 10.5781 4.79004 10.5781 5.2391C10.5781 5.68817 10.9773 6.08733 11.4264 6.08733C11.8754 6.08733 12.2746 5.73806 12.2746 5.2391Z"
          fill="#B0B7C3"
        />
        <path
          d="M7.68362 4.24121C7.38425 4.24121 7.13477 4.49069 7.13477 4.79007C7.13477 5.08944 7.38425 5.33892 7.68362 5.33892C7.983 5.33892 8.23248 5.08944 8.23248 4.79007C8.23248 4.49069 7.983 4.24121 7.68362 4.24121Z"
          fill="#B0B7C3"
        />
        <path
          d="M15.0186 19.7091C15.0186 19.8089 15.1183 19.9087 15.2181 19.9087C15.3179 19.9087 15.4177 19.8089 15.4177 19.7091C15.4177 19.6093 15.3179 19.5095 15.2181 19.5095C15.1183 19.5095 15.0186 19.6093 15.0186 19.7091Z"
          fill="#B0B7C3"
        />
        <path
          d="M14.7194 20.0083C13.9211 20.0083 13.2725 20.657 13.2725 21.4553C13.2725 22.2536 13.9211 22.9023 14.7194 22.9023C15.5178 22.9023 16.1664 22.2536 16.1664 21.4553C16.1664 20.657 15.5178 20.0083 14.7194 20.0083Z"
          fill="#B0B7C3"
        />
        <path
          d="M16.7155 21.0063C16.5159 21.0063 16.3662 21.156 16.3662 21.3556C16.3662 21.5552 16.5159 21.7049 16.7155 21.7049C16.9151 21.7049 17.0648 21.5552 17.0648 21.3556C17.0648 21.156 16.9151 21.0063 16.7155 21.0063Z"
          fill="#B0B7C3"
        />
        <path
          d="M17.9622 21.1062C17.563 21.1062 17.2637 21.4056 17.2637 21.8047C17.2637 22.2039 17.563 22.5033 17.9622 22.5033C18.3614 22.5033 18.6608 22.2039 18.6608 21.8047C18.7107 21.4555 18.3614 21.1062 17.9622 21.1062Z"
          fill="#B0B7C3"
        />
        <path
          d="M17.5131 23.1021C17.4133 23.1021 17.3135 23.2018 17.3135 23.3016C17.3135 23.4014 17.4133 23.5012 17.5131 23.5012C17.6129 23.5012 17.7126 23.4014 17.7126 23.3016C17.7126 23.2018 17.6129 23.1021 17.5131 23.1021Z"
          fill="#B0B7C3"
        />
        <path
          d="M14.0209 23.6008C13.9211 23.6008 13.8213 23.7006 13.8213 23.8004C13.8213 23.9002 13.9211 24 14.0209 24C14.1207 24 14.2205 23.9002 14.2205 23.8004C14.2205 23.7006 14.1207 23.6008 14.0209 23.6008Z"
          fill="#B0B7C3"
        />
        <path
          d="M18.4118 19.5593C18.2122 19.5593 18.0625 19.709 18.0625 19.9086C18.0625 20.1082 18.2122 20.2579 18.4118 20.2579C18.6114 20.2579 18.761 20.1082 18.761 19.9086C18.8109 19.709 18.6114 19.5593 18.4118 19.5593Z"
          fill="#B0B7C3"
        />
        <path
          d="M17.8627 20.8066C17.9625 20.8066 18.0623 20.7068 18.0623 20.6071C18.0623 20.5073 17.9625 20.4075 17.8627 20.4075C17.7629 20.4075 17.6631 20.5073 17.6631 20.6071C17.713 20.7068 17.7629 20.8066 17.8627 20.8066Z"
          fill="#B0B7C3"
        />
        <path
          d="M16.0166 5.13928C16.0166 5.23907 16.1164 5.33887 16.2162 5.33887C16.316 5.33887 16.4158 5.23907 16.4158 5.13928C16.4158 5.03949 16.316 4.9397 16.2162 4.9397C16.1164 4.9397 16.0166 5.03949 16.0166 5.13928Z"
          fill="#B0B7C3"
        />
        <path
          d="M17.2146 18.2621C17.2146 18.1623 17.1148 18.0625 17.015 18.0625C16.9152 18.0625 16.8154 18.1623 16.8154 18.2621C16.8154 18.3619 16.9152 18.4617 17.015 18.4617C17.1148 18.4617 17.2146 18.3619 17.2146 18.2621Z"
          fill="#B0B7C3"
        />
        <path
          d="M16.7149 18.6113C16.1161 18.6113 15.6172 19.1103 15.6172 19.709C15.6172 20.3078 16.1161 20.8068 16.7149 20.8068C17.3137 20.8068 17.8126 20.3078 17.8126 19.709C17.8126 19.1103 17.3137 18.6113 16.7149 18.6113Z"
          fill="#B0B7C3"
        />
        <path
          d="M18.2123 5.58838C18.3121 5.58838 18.4119 5.48859 18.4119 5.38879C18.4119 5.289 18.3121 5.18921 18.2123 5.18921C18.1125 5.18921 18.0127 5.289 18.0127 5.38879C18.0127 5.48859 18.1125 5.58838 18.2123 5.58838Z"
          fill="#B0B7C3"
        />
        <path
          d="M18.5117 16.6654C18.5117 16.865 18.6614 17.0146 18.861 17.0146C19.0606 17.0146 19.2103 16.865 19.2103 16.6654C19.2103 16.4658 19.0606 16.3161 18.861 16.3161C18.7113 16.2662 18.5117 16.4658 18.5117 16.6654Z"
          fill="#B0B7C3"
        />
        <path
          d="M18.462 17.0645C17.8632 17.0645 17.3643 17.5634 17.3643 18.1622C17.3643 18.7609 17.8632 19.2599 18.462 19.2599C19.0607 19.2599 19.5597 18.7609 19.5597 18.1622C19.5597 17.5634 19.0607 17.0645 18.462 17.0645Z"
          fill="#B0B7C3"
        />
        <path
          d="M20.1579 18.0125C19.9583 18.0125 19.8086 18.1621 19.8086 18.3617C19.8086 18.5613 19.9583 18.711 20.1579 18.711C20.3575 18.711 20.5071 18.5613 20.5071 18.3617C20.5071 18.1621 20.3575 18.0125 20.1579 18.0125Z"
          fill="#B0B7C3"
        />
        <path
          d="M21.0563 20.0583C20.8567 20.0583 20.707 20.208 20.707 20.4076C20.707 20.6072 20.8567 20.7569 21.0563 20.7569C21.2559 20.7569 21.4056 20.6072 21.4056 20.4076C21.4056 20.208 21.2559 20.0583 21.0563 20.0583Z"
          fill="#B0B7C3"
        />
        <path
          d="M21.4056 19.1602C21.3058 19.1602 21.2061 19.2599 21.2061 19.3597C21.2061 19.4595 21.3058 19.5593 21.4056 19.5593C21.5054 19.5593 21.6052 19.4595 21.6052 19.3597C21.6052 19.2599 21.5054 19.1602 21.4056 19.1602Z"
          fill="#B0B7C3"
        />
        <path
          d="M8.43201 18.7112C8.5318 18.7112 8.63159 18.6114 8.63159 18.5116C8.63159 18.4118 8.5318 18.312 8.43201 18.312C8.33221 18.312 8.23242 18.4118 8.23242 18.5116C8.23242 18.6114 8.33221 18.7112 8.43201 18.7112Z"
          fill="#B0B7C3"
        />
        <path
          d="M21.1556 14.3203C20.1577 14.3203 19.3594 15.1186 19.3594 16.1166C19.3594 17.1145 20.1577 17.9128 21.1556 17.9128C22.1536 17.9128 22.9519 17.1145 22.9519 16.1166C22.9519 15.1186 22.1536 14.3203 21.1556 14.3203Z"
          fill="#B0B7C3"
        />
        <path
          d="M23.0524 14.4202C22.8528 14.4202 22.7031 14.5699 22.7031 14.7694C22.7031 14.969 22.8528 15.1187 23.0524 15.1187C23.252 15.1187 23.4017 14.969 23.4017 14.7694C23.4516 14.5699 23.252 14.4202 23.0524 14.4202Z"
          fill="#B0B7C3"
        />
        <path
          d="M22.0046 10.3285C22.0046 10.2287 21.9048 10.1289 21.8051 10.1289C21.7053 10.1289 21.6055 10.2287 21.6055 10.3285C21.6055 10.4283 21.7053 10.5281 21.8051 10.5281C21.9048 10.578 22.0046 10.4782 22.0046 10.3285Z"
          fill="#B0B7C3"
        />
        <path
          d="M21.4552 13.8213C21.7546 13.8213 22.054 13.5718 22.054 13.2225C22.054 12.9232 21.8045 12.6238 21.4552 12.6238C21.1558 12.6238 20.8564 12.8733 20.8564 13.2225C20.8564 13.5718 21.1059 13.8213 21.4552 13.8213Z"
          fill="#B0B7C3"
        />
        <path
          d="M21.056 7.63428C20.9562 7.63428 20.8564 7.73407 20.8564 7.83386C20.8564 7.93365 20.9562 8.03345 21.056 8.03345C21.1558 8.03345 21.2556 7.93365 21.2556 7.83386C21.2057 7.68417 21.1558 7.63428 21.056 7.63428Z"
          fill="#B0B7C3"
        />
        <path
          d="M20.457 13.9711C20.457 14.0709 20.5568 14.1707 20.6566 14.1707C20.7564 14.1707 20.8562 14.0709 20.8562 13.9711C20.8562 13.8713 20.7564 13.7715 20.6566 13.7715C20.5069 13.7715 20.457 13.8713 20.457 13.9711Z"
          fill="#B0B7C3"
        />
        <path
          d="M23.6007 11.576C23.6007 10.9772 23.1017 10.4783 22.503 10.4783C21.9042 10.4783 21.4053 10.9772 21.4053 11.576C21.4053 12.1747 21.9042 12.6737 22.503 12.6737C23.1017 12.6737 23.6007 12.1747 23.6007 11.576Z"
          fill="#B0B7C3"
        />
        <path
          d="M23.3509 12.7734C22.9517 12.7734 22.6523 13.0728 22.6523 13.472C22.6523 13.8712 22.9517 14.1705 23.3509 14.1705C23.7501 14.1705 24.0494 13.8712 24.0494 13.472C24.0494 13.0728 23.7501 12.7734 23.3509 12.7734Z"
          fill="#B0B7C3"
        />
        <path
          d="M24.2497 14.2205C24.0501 14.2205 23.9004 14.3701 23.9004 14.6196C23.9004 14.8192 24.0501 14.9689 24.2996 14.9689C24.4991 14.9689 24.6488 14.8192 24.6488 14.6196C24.6488 14.3701 24.4492 14.2205 24.2497 14.2205Z"
          fill="#B0B7C3"
        />
        <path
          d="M24.5492 15.2683C24.4494 15.2683 24.3496 15.3681 24.3496 15.4679C24.3496 15.5677 24.4494 15.6675 24.5492 15.6675C24.649 15.6675 24.7488 15.5677 24.7488 15.4679C24.7488 15.3681 24.649 15.2683 24.5492 15.2683Z"
          fill="#B0B7C3"
        />
        <path
          d="M24.8483 10.2288C24.6487 10.2288 24.499 10.3784 24.499 10.578C24.499 10.7776 24.6986 10.9273 24.8982 10.9273C25.0978 10.9273 25.2475 10.7776 25.2475 10.578C25.1976 10.3784 25.0479 10.2288 24.8483 10.2288Z"
          fill="#B0B7C3"
        />
        <path
          d="M21.3553 6.93573C21.3553 6.63635 21.1558 6.43677 20.8564 6.43677C20.6069 6.43677 20.3574 6.68625 20.3574 6.93573C20.3574 7.2351 20.557 7.43469 20.8564 7.43469C21.1059 7.48458 21.3553 7.2351 21.3553 6.93573Z"
          fill="#B0B7C3"
        />
        <path
          d="M19.9082 6.5863C19.9082 6.68609 20.008 6.78589 20.1078 6.78589C20.2076 6.78589 20.3074 6.68609 20.3074 6.5863C20.3074 6.48651 20.2076 6.38672 20.1078 6.38672C20.008 6.38672 19.9082 6.48651 19.9082 6.5863Z"
          fill="#B0B7C3"
        />
        <path
          d="M18.0123 4.59063C18.0123 4.19147 17.7129 3.89209 17.3138 3.89209C16.9146 3.89209 16.6152 4.19147 16.6152 4.59063C16.6152 4.9898 16.9146 5.28918 17.3138 5.28918C17.7129 5.33908 18.0123 4.9898 18.0123 4.59063Z"
          fill="#B0B7C3"
        />
        <path
          d="M6.23678 16.0168C6.0871 16.0168 5.9873 16.1166 5.9873 16.2663C5.9873 16.416 6.0871 16.5158 6.23678 16.5158C6.38647 16.5158 6.48627 16.416 6.48627 16.2663C6.43637 16.1166 6.33658 16.0168 6.23678 16.0168Z"
          fill="#B0B7C3"
        />
        <path
          d="M8.38275 22.2037C8.13327 22.2037 7.88379 22.0041 7.88379 21.7048C7.88379 21.4553 8.08337 21.2058 8.38275 21.2058C8.63223 21.2058 8.88171 21.4054 8.88171 21.7048C8.88171 22.0041 8.63223 22.2037 8.38275 22.2037Z"
          fill="#B0B7C3"
        />
      </g>
      <defs>
        <clipPath id="clip0_2384_14931">
          <rect
            width="82.6778"
            height="24"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-if="name=== BEELINE"
      xmlns="http://www.w3.org/2000/svg"
      width="89"
      height="28"
      viewBox="0 0 89 28"
      fill="none"
    >
      <path
        d="M27.7958 13.9999C27.7958 21.5089 21.6684 27.6159 14.0913 27.6159C6.51414 27.6159 0.386719 21.5089 0.386719 13.9999C0.386719 6.47182 6.51414 0.384033 14.0913 0.384033C21.649 0.384033 27.7958 6.47182 27.7958 13.9999Z"
        fill="#F4F6F9"
      />
      <path
        d="M3.71094 22.8726C6.22376 25.7724 9.935 27.5968 14.0908 27.5968C18.2466 27.5968 21.9579 25.7724 24.4707 22.8726C23.6009 22.9878 20.8368 23.2758 14.0908 23.2758C7.1709 23.2951 4.50344 22.9878 3.71094 22.8726Z"
        fill="#B0B7C3"
      />
      <path
        d="M27.4479 17.0346C27.6798 16.0552 27.7958 15.0374 27.7958 14.0003C27.7958 12.8096 27.6412 11.6574 27.3512 10.5627C25.9982 10.5243 21.7264 10.4475 14.1492 10.4475C6.49481 10.4475 2.14569 10.5243 0.831295 10.5627C0.541354 11.6574 0.386719 12.8096 0.386719 14.0003C0.386719 15.0566 0.502695 16.0936 0.734648 17.073C2.35832 17.0922 8.75635 17.1882 14.2652 17.1882C19.8514 17.1882 26.0175 17.0538 27.4479 17.0346Z"
        fill="#B0B7C3"
      />
      <path
        d="M24.352 4.97388C21.8392 2.17004 18.1666 0.384033 14.0881 0.384033C9.99029 0.384033 6.31771 2.17004 3.82422 4.99309C4.75203 4.87786 7.51613 4.58979 14.0688 4.58979C20.5828 4.58979 23.3662 4.85866 24.352 4.97388Z"
        fill="#B0B7C3"
      />
      <path
        d="M27.7763 14C27.7763 21.5089 21.6489 27.6159 14.0718 27.6159C6.514 27.5967 0.386588 21.5089 0.386588 14C0.386588 6.47188 6.514 0.384088 14.0911 0.384088C21.6489 0.384088 27.7763 6.47188 27.7763 14ZM14.0911 0C6.30138 0 0 6.26063 0 14C0 21.7202 6.30138 28 14.0911 28C21.8615 28 28.1822 21.7394 28.1822 14C28.1822 6.26063 21.8615 0 14.0911 0Z"
        fill="#B0B7C3"
      />
      <path
        d="M65.7002 8.95253C65.7002 9.4458 66.0827 9.8384 66.576 9.8384C67.0693 9.8384 67.4518 9.45587 67.4518 8.95253C67.4518 8.45926 67.0693 8.06665 66.576 8.06665C66.0827 8.06665 65.7002 8.44919 65.7002 8.95253Z"
        fill="#B0B7C3"
      />
      <path
        d="M70.3007 11.8416L70.2504 11.8718L70.1396 11.5597C70.0994 11.449 69.9987 11.3785 69.888 11.3785H69.3242C69.1732 11.3785 69.0625 11.4993 69.0625 11.6403V18.9286C69.0625 19.0695 69.1833 19.1903 69.3242 19.1903H70.341C70.492 19.1903 70.6027 19.0695 70.6027 18.9286V13.0295L70.6329 13.0194C71.0557 12.808 71.4785 12.6671 72.304 12.6671C73.2905 12.6671 73.4919 13.0396 73.4919 13.6335V18.9286C73.4919 19.0695 73.6127 19.1903 73.7536 19.1903H74.7704C74.9113 19.1903 75.0321 19.0695 75.0321 18.9286V13.6838C75.0321 12.0832 74.0858 11.2275 72.2939 11.2275C71.6396 11.2376 70.9651 11.4389 70.3007 11.8416Z"
        fill="#B0B7C3"
      />
      <path
        d="M67.3309 11.6402C67.3309 11.4892 67.2101 11.3784 67.0591 11.3784H66.0726C65.9216 11.3784 65.8008 11.4992 65.8008 11.6402V18.9184C65.8008 19.0694 65.9216 19.1802 66.0726 19.1802H67.0591C67.2101 19.1802 67.3309 19.0594 67.3309 18.9184V11.6402Z"
        fill="#B0B7C3"
      />
      <path
        d="M63.9478 8.00618C63.9478 7.86524 63.827 7.73438 63.676 7.73438H62.6895C62.5485 7.73438 62.4277 7.85517 62.4277 8.00618V18.9286C62.4277 19.0796 62.5485 19.1904 62.6895 19.1904H63.676C63.827 19.1904 63.9478 19.0695 63.9478 18.9286V8.00618Z"
        fill="#B0B7C3"
      />
      <path
        d="M47.1465 15.2945C47.1465 16.2911 47.1465 19.3414 50.4685 19.3414C51.4651 19.3414 52.1195 19.281 52.9751 19.0091C53.0758 18.9789 53.1261 18.8682 53.1261 18.7675V17.9421C53.1261 17.8515 53.0859 17.7609 53.0053 17.7206C52.9349 17.6703 52.8443 17.6803 52.7537 17.7005C52.0087 17.8615 51.4249 17.9018 50.4685 17.9018C49.0793 17.9018 48.8176 17.026 48.727 16.0797L48.7169 16.0193H53.2268C53.3778 16.0193 53.4885 15.8985 53.4885 15.7475V15.2844C53.4885 13.3214 53.257 11.2275 50.4685 11.2275C47.1465 11.2376 47.1465 14.2878 47.1465 15.2945ZM48.7169 14.5999C48.7974 13.5932 49.0592 12.6671 50.4685 12.6671C51.6765 12.6671 51.9081 13.3214 51.9383 14.5999V14.6502H48.7169V14.5999Z"
        fill="#B0B7C3"
      />
      <path
        d="M54.6865 15.2945C54.6865 16.2911 54.6865 19.3414 58.0086 19.3414C59.0052 19.3414 59.6595 19.281 60.5152 19.0091C60.6158 18.9789 60.6762 18.8682 60.6762 18.7675V17.9421C60.6762 17.8515 60.636 17.7609 60.5554 17.7206C60.485 17.6703 60.3944 17.6803 60.3038 17.7005C59.5588 17.8615 58.9649 17.9018 58.0086 17.9018C56.6294 17.9018 56.3576 17.026 56.267 16.0797V16.0193H60.7769C60.9178 16.0193 61.0387 15.8985 61.0387 15.7475V15.2844C61.0387 13.3214 60.797 11.2275 58.0086 11.2275C54.6865 11.2376 54.6865 14.2878 54.6865 15.2945ZM56.2569 14.5999C56.3274 13.5932 56.5992 12.6671 57.9985 12.6671C59.2065 12.6671 59.438 13.3214 59.4682 14.5999V14.6502H56.2469L56.2569 14.5999Z"
        fill="#B0B7C3"
      />
      <path
        d="M76.3711 15.2945C76.3711 16.2911 76.3711 19.3414 79.6931 19.3414C80.6897 19.3414 81.3441 19.281 82.1997 19.0091C82.3004 18.9789 82.3608 18.8682 82.3608 18.7675V17.9421C82.3608 17.8515 82.3205 17.7609 82.24 17.7206C82.1695 17.6703 82.0789 17.6803 81.9984 17.7005C81.2535 17.8615 80.6595 17.9018 79.7032 17.9018C78.324 17.9018 78.0522 17.026 77.9616 16.0797L77.9516 16.0193H82.4615C82.6024 16.0193 82.7232 15.8985 82.7232 15.7475V15.2844C82.7232 13.3214 82.4917 11.2275 79.6931 11.2275C76.3711 11.2376 76.3711 14.2878 76.3711 15.2945ZM77.9516 14.5999C78.0321 13.5932 78.2938 12.6671 79.7032 12.6671C80.9112 12.6671 81.1427 13.3214 81.1729 14.5999V14.6502H77.9516V14.5999Z"
        fill="#B0B7C3"
      />
      <path
        d="M38.5895 7.69434C38.4284 7.69434 38.3076 7.8252 38.3076 7.9762V18.9087C38.3076 19.0698 38.4385 19.1906 38.5895 19.1906H42.133C44.6698 19.1906 46.0691 17.9926 46.0691 15.8383C46.0691 14.6605 45.5054 13.6539 44.549 13.1505C44.549 13.1505 44.5289 13.1405 44.5087 13.1203C44.5289 13.1103 44.549 13.0901 44.549 13.0901C45.2839 12.5465 45.7067 11.7412 45.7067 10.8654C45.7067 9.68756 45.2235 7.69434 42.0323 7.69434H38.5895ZM42.1129 9.23455C43.7638 9.23455 43.9953 10.0198 43.9953 10.8654C43.9953 11.9526 43.4215 12.476 42.2337 12.476H39.9183V9.23455H42.1129ZM42.2236 14.0062C43.794 14.0062 44.3477 14.4793 44.3477 15.8283C44.3477 16.7343 44.096 17.6504 42.1934 17.6504H39.9082V13.9961H42.2236V14.0062Z"
        fill="#B0B7C3"
      />
      <path
        d="M84.9384 10.8349H84.7572C84.7471 10.8349 84.737 10.8349 84.737 10.8248L84.0928 9.02287C84.0928 9.01281 84.0928 9.01281 84.0928 9.00274C84.1028 8.99268 84.1028 8.99268 84.1129 8.99268H84.3847C84.3948 8.99268 84.4048 9.00274 84.4048 9.01281L84.8377 10.3316L85.2706 9.01281C85.2706 9.00274 85.2806 8.99268 85.2907 8.99268H85.5726C85.5826 8.99268 85.5827 8.99268 85.5927 9.00274C85.6028 9.01281 85.6028 9.01281 85.5927 9.02287L84.9484 10.8248C84.9585 10.8248 84.9484 10.8349 84.9384 10.8349Z"
        fill="#B0B7C3"
      />
      <path
        d="M87.1033 10.8049H86.902L86.0866 9.57673L86.0966 10.7847C86.0966 10.7948 86.0966 10.7948 86.0866 10.8049C86.0866 10.8049 86.0765 10.8149 86.0664 10.8149H85.8248C85.8147 10.8149 85.8047 10.8049 85.8047 10.7948V9.02306C85.8047 9.01299 85.8147 9.00293 85.8248 9.00293H86.0262L86.8416 10.2411V9.03313C86.8416 9.03313 86.8416 9.02306 86.8416 9.01299L86.8516 9.00293H87.1033C87.1134 9.00293 87.1234 9.01299 87.1234 9.02306V10.7948C87.1234 10.7948 87.1134 10.8049 87.1033 10.8049Z"
        fill="#B0B7C3"
      />
      <path
        d="M83.166 9.87851C83.166 8.48929 84.2935 7.36182 85.6827 7.36182C87.0719 7.36182 88.1994 8.48929 88.1994 9.87851C88.1994 11.2677 87.0719 12.3952 85.6827 12.3952C84.2935 12.3952 83.166 11.2677 83.166 9.87851ZM83.5586 9.87851C83.5586 11.0463 84.5049 11.9925 85.6726 12.0026C86.8404 12.0026 87.7867 11.0463 87.7867 9.87851C87.7867 8.7007 86.8404 7.75442 85.6726 7.75442C84.5049 7.75442 83.5687 8.7007 83.5586 9.87851Z"
        fill="#B0B7C3"
      />
    </svg>
  </div>
</template>

<script lang="ts">
import { TELE2, ALTEL, BEELINE, ACTIV, KCELL } from '@/constant';
export default {
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  setup () {
    return {
      TELE2,
      ALTEL,
      ACTIV,
      BEELINE,
      KCELL
    };
  }
};
</script>

<style>

</style>